import styled from 'styled-components';

export const Map = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 20px;
`;

export const Item = styled.a`
    margin: 0 20px 0 20px;
`;

export const Icon = styled.img`
    width: 50px;
    margin-bottom: 10px;
`;

export const Labels = styled.div`
    color: #fff;
`;

export const Title = styled.p`
    font-size: 14px;
`;

export const SecondaryTitle = styled.p`
    font-size: 14px;
    font-weight: 300;
`;
